import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

const Loading = () => {
  return <Spinner icon={faSpinner} />;
};

export default Loading;

const Spinner = styled(FontAwesomeIcon)`
  @keyframes spinner {
    to {
      transform: rotate(360deg);
    }
  }
  animation: spinner 1s linear infinite;
`;
